<ng-container *transloco="let t">
  <app-editable-text
    appNavBreadcrumb
    [label]="strategyGroupName()"
    [tooltipText]="t('sp-strategy-group-page.change_strategy_group_name')"
    [disable]="!!isReadOnly()"
    (textChange)="updateStrategyName($event)"
  />
  <div class="flex h-full flex-col gap-4">
    @if (syncMessage(); as message) {
      <app-sync-info class="flex min-w-0" [message]="message" />
    }
    <ITabs [tabs]="tabs()" [(activeTab)]="activeTab" />
    @if (strategyGroup()) {
      <div class="flex-1 px-2">
        @switch (selectedSection()) {
          @case (SECTIONS.PRODUCTS) {
            <app-strategy-group-products
              class="h-full"
              [strategyGroup]="strategyGroup()"
              [strategiesPerAsin]="strategiesPerAsin()"
              [isReadOnly]="!!isReadOnly()"
            />
          }
          @case (SECTIONS.CAMPAIGNS) {
            <app-strategy-group-strategies class="h-full" [strategyGroup]="strategyGroup()" />
          }
          @case (SECTIONS.STATS) {
            <div class="ag-theme-quartz h-full">
              @if (strategyGroup(); as strategyGroup) {
                <app-sp-strategy-stats-graph [strategyGroup]="strategyGroup" />
              }
              <app-advertising-stats-grid
                [fullHeight]="true"
                gridKey="strategyGroupStats"
                [hiddenColumns]="hiddenColumns"
                [dataFilter]="strategyGroupStatsFilter()"
                [noStrategyLinks]="true"
                (export)="exportGridCsv()"
              />
            </div>
          }
          @case (SECTIONS.ACTIVITIES) {
            <app-activity-component
              class="h-full"
              [activityFilter]="activityFilter()"
              gridConfigStorageKey="strategyGroupActivities"
            />
          }
        }
      </div>
    }
  </div>
</ng-container>
